var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimitsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    rx: 6,
    fill: "#3B58FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10H24.5C23.3954 10 22.5 10.8954 22.5 12V26C22.5 27.1046 23.3954 28 24.5 28H25.5C26.6046 28 27.5 27.1046 27.5 26V12C27.5 10.8954 26.6046 10 25.5 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16H18C16.8954 16 16 16.8954 16 18V26C16 27.1046 16.8954 28 18 28H19C20.1046 28 21 27.1046 21 26V18C21 16.8954 20.1046 16 19 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23H11.5C10.3954 23 9.5 23.8954 9.5 25V26C9.5 27.1046 10.3954 28 11.5 28H12.5C13.6046 28 14.5 27.1046 14.5 26V25C14.5 23.8954 13.6046 23 12.5 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitsIcon);
export default __webpack_public_path__ + "static/media/limits-icon.af3c5e8cb0092341692f10bc508633ff.svg";
export { ForwardRef as ReactComponent };